export default __webpack_public_path__ + "img/total-loan-icon.700d8e5e.svg";